<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <router-link tag="button" class="btn btn-info float-right" :to="{ name: 'AddUser' }">
              Create Account
            </router-link>
            <h3 class="card-title pb-3">Users</h3>
            <data-table
              :columns="columns"
              fieldName="users"
              :query="query"
              :variables="variables"
              placeholder="Search by Name"
            >
              <select slot="additional-filter" v-model="roleId" class="form-control">
                <option value="">All roles</option>
                <option v-for="role of roles" :key="role.id" :value="role.id">{{ role.role_type }}</option>
              </select>
              <span slot="photo" slot-scope="props">
                <router-link :to="{ name: 'UserPhoto', params: { id: props.row.id } }">
                  <img width="50px" v-if="props.row.photo && props.row.photo.thumb50" :src="props.row.photo.thumb50" class="img-circle">
                  <i v-else class="mdi mdi-account-circle user-icon"></i>
                </router-link>
              </span>
              <span slot="name" slot-scope="props">
                <router-link :to="{ name: 'UpdateUser', params: { userId: props.row.id } }">
                  {{props.row.name}}
                </router-link>
              </span>
              <span slot="companyName" slot-scope="props">
                <router-link :to="{ name: 'EditCompany', params: { id: props.row.companyId } }">
                  {{ props.row.companyName }}
                </router-link>
              </span>
              <span slot="status" slot-scope="props">
                {{ props.row.status ? 'Active' : 'Inactive' }}
              </span>
              <span slot="created" slot-scope="props">
                {{ props.row.created | moment("MMM Do YYYY, h:mm:ss a") }}
              </span>
              <span slot="actions" slot-scope="props">
                <router-link :to="{ name: 'UpdateUser', params: { userId: props.row.id } }">
                  <i class="mdi mdi-pencil text-inverse m-r-10"></i>
                </router-link>
                <router-link
                  v-granted="'users.find'"
                  v-if="props.row.role_type !== 'administrator'"
                  :to="{ name: 'AssignCampaigns', params: { userId: props.row.id, role: props.row.role_type } }"
                >
                  <i class="mdi mdi-checkbox-marked-outline text-inverse"></i>
                </router-link>
              </span>
            </data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable';
import USERS from '@/graphql/Users/Users.gql';
import USER_ROLE from '@/graphql/Users/UserRole.gql';

export default {
  name: 'Users',
  components: {
    DataTable,
  },

  data() {
    return {
      columns: [
        { field: 'id', title: 'Id' },
        { field: 'photo', title: 'Photo' },
        { field: 'name', title: 'Name' },
        { field: 'role_type', title: 'Role' },
        { field: 'email', title: 'Email' },
        { field: 'companyName', title: 'Company' },
        { field: 'status', title: 'Status' },
        { field: 'phone', title: 'Phone' },
        { field: 'created', title: 'Created' },
        { field: 'actions', title: 'Actions', skipSorting: true },
      ],
      query: USERS,
      roles: [],
      roleId: '',
    };
  },

  computed: {
    variables() {
      const filter = {};
      if (this.roleId) {
        filter.roleId = this.roleId;
      }
      return {
        filter,
      };
    },
  },

  apollo: {
    roles: {
      query: USER_ROLE,
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (!loading) {
          this.roles = data.roles;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.user-icon {
  font-size: 50px;
}
.table td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/Users.vue